module.exports = __webpack_public_path__ + "static/media/017-moon.a6285326.svg";